import { GanttTabBarTab } from "../types/ganttChart";
import { FullTimelineRange } from "../types/timeline";

class ganttCHartValues {
  // ####### HORIZONTAL VIEW #########
  // Rows
  static rowHeightForBoth = 80;
  static rowHeightForBothString = "80px";
  static rowHeight = 40;
  static rowHeightString = "40px";
  static expandedRowHeight = 60;
  static expandedRowHeightString = "60px";
  static headerRowHeight = 40;
  static expandedUnplannedRowHeight = 60;
  static individualUnplannedRowHeight = 30;

  // Columns
  static nameColumnWidth = 200;
  static nameColumnWidthString = "300px";

  // Tasks
  static individualTaskHeight = 20;
  static expandedIndividualTaskHeight = 40;
  static taskTextLineHeight = 18;
  // Todo: change
  // Colors (outdated)
  static mochaColor = "var(--col-graph-second)";
  static mochaColor40 = "var(--col-graph-second-40)";

  // Movement params
  static zoomInHours = 3;
  static jumpInHours = 0.5;
}
export default ganttCHartValues;

export class ganttChartVerticalValues {
  // ####### VERTICAL VIEW #########
  static timelineColumn = 76;
  static verticalViewMinColumnWidth = 35;
  static unplannedColumnMinWidth = 90;
  static unplannedMinWidth = 10;
  static verticalViewTextRowHeight = 34;
  static verticalViewColumn = 34;
  static allowedNumberOfColumnIncludingUnPlanned = 50;
  static verticalGanttChartHeight = 720;
  static verticalSvgHeight =
    this.verticalGanttChartHeight + this.verticalViewTextRowHeight * 4;

  // KPI header
  static kpiCompactThreshold = 100;
  static kpiTransportMinWidth = 60;

  // Movement params
  static zoomInHoursOnVertical = 3;
  static jumpInHoursOnVertical = 1;

  static getTaskWidth = (verticalColumnWidth: number) => {
    return verticalColumnWidth! >= this.verticalViewMinColumnWidth
      ? verticalColumnWidth! - 4
      : this.verticalViewMinColumnWidth - 4;
  };

  static getOverlayWidth = (verticalColumnWidth: number) => {
    return verticalColumnWidth! >= this.verticalViewMinColumnWidth
      ? verticalColumnWidth!
      : this.verticalViewMinColumnWidth;
  };

  static findTaskYPosition = (
    timelineRange: FullTimelineRange,
    pixelPerMinute: number,
    startTime: string,
  ) => {
    const differenceInMiliseconds =
      new Date(startTime).getTime() -
      new Date(timelineRange.earliestHourDisplayedOnTimeline).getTime();
    const differenceInMinutes = differenceInMiliseconds / 60000;

    return differenceInMinutes * pixelPerMinute;
  };
}
